var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0258 13.8469L18.595 17.4152L17.4158 18.5943L13.8475 15.0252C12.5198 16.0895 10.8683 16.6684 9.16666 16.666C5.02666 16.666 1.66666 13.306 1.66666 9.16602C1.66666 5.02602 5.02666 1.66602 9.16666 1.66602C13.3067 1.66602 16.6667 5.02602 16.6667 9.16602C16.6691 10.8677 16.0902 12.5191 15.0258 13.8469ZM13.3542 13.2285C14.4118 12.1409 15.0024 10.683 15 9.16602C15 5.94268 12.3892 3.33268 9.16666 3.33268C5.94332 3.33268 3.33332 5.94268 3.33332 9.16602C3.33332 12.3885 5.94332 14.9993 9.16666 14.9993C10.6837 15.0017 12.1416 14.4111 13.2292 13.3535L13.3542 13.2285Z",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSearch);
export default __webpack_public_path__ + "static/media/filterSearch.b6d4978f493c06aadbc822b87df7c91b.svg";
export { ForwardRef as ReactComponent };